import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import { Icon, Typography } from '@npm-registry/eapteka-ui';
import { ExpirationProps } from './types';
import styles from './Expiration.scss';

export const Expiration: FC<ExpirationProps> = ({
  className,
  icon = 'timeRound',
  iconColor = '#ff1f78',
  text
}) => {
  const style = useMemo(
    () => ({
      color: iconColor
    }),
    [iconColor]
  );

  return (
    <div
      className={clsx([styles.root, className])}
      style={style}
    >
      <Icon className={styles.icon} name={icon} />
      <Typography className={styles.text}>
        {text}
      </Typography>
    </div>
  );
};
